/*
 *  Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('ShareGroupsInterceptor', [
        '$translate',
        'Session',
        function (
            $translate,
            Session
        ) {
        return {
            response: (response) => angular.isArray(response.resource) ?
                response.resource.map(PublicFoldersDecorator) :
                PublicFoldersDecorator(response.resource)
        };

        function PublicFoldersDecorator(group) {
            Object.defineProperties(group, {
                currentUserGroupRoles: {
                    get: () => group.current_user_roles.map((role) => {
                        switch (role) {
                            case 'owner':
                                return $translate.instant('share_groups_role_owner');
                            case 'member':
                                return $translate.instant('share_groups_role_member');
                        }
                    }).join(', ')
                },
                isCurrentUserGroupOwner: {
                    get: () => group.owner && group.owner.uuid === Session.account.uuid
                },
                description: {
                    value: group.everyone ?
                        $translate.instant('share_groups_view_group_modal_input_description_placeholder') :
                        group.description
                }
            });

            return group;
        }
    }]);
